/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import { memo, useEffect, useState } from 'react';

import { lazy } from '@loadable/component';
import Pullable from 'react-pullable';
import MediaQuery from 'react-responsive';

import { isAuthenticated } from 'actions/user';
import ChartScreen from 'components/placeorder_v2/ChartScreen';
import Render from 'components/render';
import { device } from 'helpers/screenSizes';
import { useChartTabs } from 'hooks/useChartTabs';
import useTheme from 'hooks/useTheme';
import { socketActiveSelector } from 'selectors/socketSelectors';
import {
  isOnlineSelector,
  selectedProductContractType,
  selectedProductSymbol,
} from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';
import { ContractType } from 'types/IProducts';

import { CHART_TABS } from './chart.constants';
import ChartStyle from './chart_style';
import FundingTvContainer from './FundingTvContainer';
import classes from './index.module.scss';
import TradingViewContainer from './TradingViewContainer';

const DepthChart = lazy(
  () =>
    import(
      /* webpackChunkName: "DepthChart", webpackPrefetch: true */ 'containers/depth_chart'
    )
);

const WidgetTabs = lazy(() => import(/* webpackChunkName: "WidgetTabs" */ '../tabs'));

const Charts = () => {
  const isLoggedIn = useAppSelector(({ user }) => isAuthenticated(user));
  const [isNewChartToBeLoaded, setIsNewChartToBeLoaded] = useState(false);

  const { activeTheme } = useTheme();
  const productSymbol = useAppSelector(selectedProductSymbol);
  const productContractType = useAppSelector(selectedProductContractType);
  const isOnline = useAppSelector(isOnlineSelector);
  const socketActive = useAppSelector(socketActiveSelector);

  const { activeTab, onTabClick, filteredTabs } = useChartTabs();

  // TODO: Get it tested and then make it proper
  useEffect(() => {
    if (isOnline && socketActive) {
      setIsNewChartToBeLoaded(true);
    }
  }, [isOnline, socketActive]);

  useEffect(() => {
    if (isNewChartToBeLoaded) {
      setIsNewChartToBeLoaded(false);
    }
  }, [isNewChartToBeLoaded]);

  if (isNewChartToBeLoaded) {
    return null;
  }

  return (
    <Pullable
      spinnerColor="var(--brand-bg-primary)"
      onRefresh={() => window.location.reload()}
    >
      <div className={classes.chartAndQuantityContainer}>
        <ChartStyle
          activeTab={activeTab}
          contractType={productContractType}
          isLoggedin={isLoggedIn}
        >
          <MediaQuery query={device.up.md}>
            <div className="col-md-24 col-sm-24 col-xs-24 col-xxs-24 chart-widgets">
              <WidgetTabs
                data-testid="bjvibkpCu3NzL-Uac2J0f"
                tabList={filteredTabs}
                onClick={onTabClick}
                activeTab={activeTab}
                className="chart-tabs"
                tabLength="50"
              />
            </div>
          </MediaQuery>
          {(activeTab === CHART_TABS.PRICE_CHART ||
            activeTab === CHART_TABS.MARK_CHART ||
            activeTab === CHART_TABS.INDEX_PRICE_CHART) &&
          productSymbol ? (
            <TradingViewContainer activeTab={activeTab} />
          ) : null}
          {activeTab === CHART_TABS.FUNDING_CHART ? (
            <FundingTvContainer key={`${activeTheme}`} />
          ) : null}
          {activeTab === CHART_TABS.DEPTH_CHART ? <DepthChart /> : null}
        </ChartStyle>
        <Render when={productContractType !== ContractType.Tracker}>
          <ChartScreen />
        </Render>
      </div>
    </Pullable>
  );
};

export default memo(Charts);
